/* eslint-disable indent */
/* eslint-disable lines-between-class-members */
/* eslint-disable semi-style */
/* eslint-disable switch-colon-spacing */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable function-paren-newline */
/* eslint-disable no-buffer-constructor */
/* eslint-disable getter-return */
/* eslint-disable for-direction */
/* eslint-disable import/no-unresolved */
import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import EventsPage from '@/components/events/EventsPage.vue';
import ContactPage from '@/components/contact/ContactPage.vue';
import GalleryPage from '@/components/gallery/GalleryPage.vue';
import AlbumPage from '@/components/album/AlbumPage.vue';
import CategoryPage from '@/components/category/CategoryPage.vue';
import VideosPage from '@/components/videos/VideosPage.vue';
import MainPage from '@/components/main/MainPage.vue';

Vue.use(VueAxios, axios);

Vue.use(Router);

export default new Router({
  routes: [{
    path: '/',
    name: 'MainPage',
    component: MainPage,
  },
  {
    path: '/videos',
    name: 'VideosPage',
    component: VideosPage,
  },
  {
    path: '/events',
    name: 'EventsPage',
    component: EventsPage,
  },
  {
    path: '/contact',
    name: 'ContactPage',
    component: ContactPage,
  },
  {
    path: '/gallery',
    name: 'GalleryPage',
    component: GalleryPage,
  },
  {
    path: '/gallery/:category',
    name: 'CategoryPage',
    component: CategoryPage,
  },
  {
    path: '/gallery/:category/:album',
    name: 'AlbumPage',
    component: AlbumPage,
  },
  {
    path: '*',
    component: MainPage,
  },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js